import axios from 'axios'
import {Response} from '@/domain/Common'
import env from '@//util/Env'

export class PMStrategyService {
  public static get(pms: string): Promise<PMStrategy> {
    return axios
      .get<Response<PMStrategy>>(`${env.ApiUrl}/public/portfolio/${pms}`)
      .then((res) => {
        return res.data.result
      })
  }
}

export interface PMStrategy {
  code: string
  name: string
  description: string
  descriptionShort: string
  strength: string
  exampleStocks: ExampleStock[]
  pdf1: string
  pdf2: string
  risk: string
  exposures: Exposures
  idealExposures: Exposures
  composition: Composition[]
  performance: Performance
  topixPerformance: TopixPerformance
  esgScore: string
}

export interface ExampleStock {
  code: string
  name: string
}

export interface Exposures {
  exposure1: number
  exposure2: number
  exposure3: number
  exposure4: number
  exposure5: number
  exposure6: number
  exposure7: number
  exposure8: number
  topix: number
}

export interface Composition {
  stockCode: string
  stockName: string
  componentRatio: string
}

export interface Performance {
  performance3y: string
  performance1y: string
  performance1m: string
}

export interface TopixPerformance {
  performance1y: string
}
